export default "__VITE_ASSET__BGBinZKQ__"